import React from 'react';
import { content } from '../data/mock';
import './Areas.css';

const Areas = ({ language }) => {
  const t = content[language].areas;

  return (
    <section id="areas">
      <div className="container service-map">
        <div className="map-box">
          <h2 style={{ marginTop: 0 }}>{t.title}</h2>
          <p>{t.description}</p>
          <div className="city-grid">
            {t.cities.map((city, index) => (
              <div key={index} className="city">
                {city}
              </div>
            ))}
          </div>
        </div>
        <div className="panel">
          <h3 style={{ marginTop: 0 }}>{t.whyTitle}</h3>
          <div className="list">
            {t.whyItems.map((item, index) => (
              <div key={index} className="item">
                <span className="check-number">{index + 1}</span>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Areas;
